import { render } from "./AudioLibraryManager.vue?vue&type=template&id=5ed860dc&scoped=true"
import script from "./AudioLibraryManager.vue?vue&type=script&lang=ts"
export * from "./AudioLibraryManager.vue?vue&type=script&lang=ts"

import "./AudioLibraryManager.vue?vue&type=style&index=0&id=5ed860dc&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-5ed860dc"

export default script